import {Component, OnInit} from '@angular/core';
import {CrCustomerDto} from "../../../../../feature-crm/cr/model/dto/entity/cr-customer.dto";
import {CustomerService} from "../../../../../feature-crm/cr/service/api/customer.service";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {ObjectIdentifier} from "../../../../../core/shared/basic/object-identifier";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {WidgetDataParam} from "../../../../../core/shared/widget/widget-data-param";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {Sorting} from "../../../../../core/shared/misc/sorting";

@Component({
    selector: 'mvs-xx-widget-page',
    templateUrl: './xx-widget.page.html',
    styleUrls: ['./xx-widget.page.scss'],
    standalone: false
})
export class XxWidgetPage implements OnInit {

  initialized: boolean;

  tableWidgetData: WidgetData;

  customerWidgetData: WidgetData;

  personWidgetData: WidgetData;

  contactsWidgetData: WidgetData;

  selectedObject: ObjectIdentifier;

  customerDto: CrCustomerDto;

  constructor(protected customerService: CustomerService) {
  }

  ngOnInit(): void {

    this.initWidgets();

    this.initialized = true;
  }

  onCustomerSelect(objectIdentifier: ObjectIdentifier) {

    // load customer details
    this.customerService.get(objectIdentifier.objectId).subscribe(value => {
      this.customerDto = <CrCustomerDto>value;
      this.selectedObject = objectIdentifier;
      this.refreshWidgets();
    });

  }


  refreshWidgets() {

    // HEADER INFORMATION
    this.customerWidgetData = WidgetFactory.createWidgetEntityData(
        'xx.widget.customer.data',
        `Customer: ${this.selectedObject.objectId}`,
        'cr.Customer',
        this.selectedObject.objectId,
        WidgetDataParam.create("showHeader", true),
        WidgetDataParam.create("headerText", "Header Text"),
        WidgetDataParam.create("showSubHeader", true),
        WidgetDataParam.create("subHeaderText", "Sub Header Text"));
    // CUSTOMER CONTACT
    // let filterCriteria = FilterCriteria.create("customer", FilterCriteria.cOperatorEqual,this.selectedObject.objectId, null );
    // const dataProviderListRequest = new ObjectRequestList(
    //     true,
    //     [filterCriteria],
    //     [new Sorting("createdDate", false)]
    // );
    // this.contactsWidgetData = WidgetFactory.createWidgetListEntity(
    //     'xx.widget.contacts.simple',
    //     'Customer Contacts',
    //     'cr.CustomerContact',
    //     'No Customer Contacts Found.',
    //     dataProviderListRequest,
    //     WidgetDataParam.create("size", "S"),
    //     WidgetDataParam.create("objectWidget", "data")
    // );
      this.contactsWidgetData = WidgetFactory.createWidgetListEntityQl('xx.widget.contacts.simple.new', 'Customer Contacts', 'cr.CustomerContact', 'No Customer Contacts Found.', [
          FilterCriteria.create(
              "e.customerId",
              FilterCriteria.cOperatorEqual,
              this.selectedObject.objectId
          )
      ], [
          new Sorting("e.createdDate", false)
      ], false, WidgetDataParam.create("size", "S"), WidgetDataParam.create("objectWidget", "data"));



      // PERSON INFORMATION
    this.personWidgetData = WidgetFactory.createWidgetEntityData(
        'xx.widget.person.data',
        `Person: ${this.customerDto.personDtoId}`,
        'pm.Person',
        this.customerDto.personDtoId,
        WidgetDataParam.create("showHeader", true),
        WidgetDataParam.create("headerText", "Header Text"),
        WidgetDataParam.create("showSubHeader", true),
        WidgetDataParam.create("subHeaderText", "Sub Header Text"));
  }


  initWidgets() {
    // const dataProviderListRequest = ObjectRequestList.createWithPaging(
    //     true,
    //     [],
    //     [new Sorting("createdDate", false)],
    //     PagingDto.create(0, 5)
    // );
    // this.tableWidgetData = WidgetFactory.createWidgetTableEntity(
    //     'xx.widget.table.simple',
    //     'Customer',
    //     'cr.Customer',
    //     'No Customers Found.',
    //     dataProviderListRequest,
    //     WidgetDataParam.create("selectionMode", "single"),
    //     WidgetDataParam.create("size", "S")
    // );
      this.tableWidgetData = WidgetFactory.createWidgetTableEntityQl('xx.widget.table.simple.new', 'Customer', 'cr.Customer', 'No Customers Found.', [], [
          new Sorting("e.createdDate", false)
      ], false, WidgetDataParam.create("selectionMode", "single"), WidgetDataParam.create("size", "S"));

  }



}
